<template>
	<div
		class="side_btn s"
		:class="{ upper: hasFixedButtons }"
		:style="{
			...styles,
		}"
	>
		<button id="channel_service" type="button" class="btn_channelService" v-if="showsBizTalk" @click="crmClick">
			<i class="ico24_chatbot" />
			<span class="channel_badge" v-if="channelBadgeCnt > 0">{{ channelBadgeCnt | badgeCount }}</span>
			<span class="txt_hidden">비즈톡으로 이동</span>
		</button>

		<button
			type="button"
			class="btn_gotop"
			v-if="isActivatedScrollTopButton"
			:class="{ on: isActivatedScrollTopButton }"
			@click="moveTop"
		>
			<span class="txt_hidden">맨위로</span>
		</button>
	</div>
</template>

<script>
import wildcard from 'wildcard';
import { mapGetters } from 'vuex';

import { crmFloatingClick } from '@/helpers/ad/crm/crm.js';

export default {
	data() {
		return {
			isActivatedScrollTopButton: false,
		};
	},

	computed: {
		...mapGetters(['showsQuickNavigator', 'hasFixedButtons', 'channelBadgeCnt']),
		/**
		 * 상황별 Custom styles
		 */
		styles() {
			// 공지사항 상세 화면에서 하단 여백 10% 추가
			if (['/noticeView'].some(path => wildcard(path, this.$route.path))) return { marginBottom: '10%' };
			if (['/order'].some(path => wildcard(path, this.$route.path))) return { marginBottom: '100px' };
			if (['/order/step2'].some(path => wildcard(path, this.$route.path))) return { marginBottom: '100px' };
			if (['/estimate/list'].some(path => wildcard(path, this.$route.path))) return { marginBottom: '100px' };
			if (['/survey/defaultsend'].some(path => wildcard(path, this.$route.path))) return { marginBottom: '140px' };
			if (['/survey/defaultorder'].some(path => wildcard(path, this.$route.path))) return { marginBottom: '100px' };
			if (['/survey/defaultorder/step2'].some(path => wildcard(path, this.$route.path)))
				return { marginBottom: '100px' };
			if (['/survey/defaultorder/success'].some(path => wildcard(path, this.$route.path)))
				return { marginBottom: '100px' };
			if (['/survey/lotterysend'].some(path => wildcard(path, this.$route.path))) return { marginBottom: '140px' };
			if (['/survey/lotteryorder'].some(path => wildcard(path, this.$route.path))) return { marginBottom: '100px' };
			if (['/survey/lotteryorder/step2'].some(path => wildcard(path, this.$route.path)))
				return { marginBottom: '100px' };
			if (['/survey/lotteryorder/success'].some(path => wildcard(path, this.$route.path)))
				return { marginBottom: '100px' };

			return {};
		},

		/** 비즈톡(챗봇) 버튼 노출상태 */
		showsBizTalk() {
			/** bizTalk 미사용 경로 목록 */
			const BIZTALK_BUTTON_DISABLED_PAGES = ['/checkguide', '/notFound'];
			return !BIZTALK_BUTTON_DISABLED_PAGES?.some(path => wildcard(path, this.$route.path));
		},
	},

	methods: {
		moveTop() {
			window.scroll({
				top: 0,
				left: 0,
				behavior: 'smooth',
			});
		},

		detectedPosition() {
			/** 현재 스크롤Y 위치 값 */
			const basePoint = window.scrollY;
			/** 탑버튼 보이는 기준 위치 값 */
			const visiblePoint = window.outerHeight;

			if (basePoint > visiblePoint) {
				this.isActivatedScrollTopButton = true;
			} else {
				this.isActivatedScrollTopButton = false;
			}
		},

		/** crm 플로팅 메뉴 클릭 */
		crmClick() {
			crmFloatingClick('channeltalk');
		},
	},

	filters: {
		badgeCount(cnt) {
			return cnt > 99 ? '99+' : cnt;
		},
	},

	created() {
		window.addEventListener('scroll', this.detectedPosition);
	},

	destroyed() {
		window.removeEventListener('scroll', this.detectedPosition);
	},
};
</script>

<style>
.side_btn .channel_badge {
	display: flex;
	align-items: center;
	justify-content: center;
	position: absolute;
	bottom: 25px;
	left: 27px;
	width: 20px;
	height: 20px;
	border-radius: 50%;
	font-size: 0.56rem;
	color: #fff;
	background: var(--red);
}
</style>
